import {useContext, useMemo} from "react";

import {Styled} from "./MainPage.styled"
import Hero from "./Sections/Hero";
import GearRail from "./Sections/GearRail";
import BrandMarquee from "./Sections/BrandMarquee";
import ContactBand from "./Sections/ContactBand";
import {Local_Data} from "../../Context";
import {toProductList} from "../../lib/products";

const DEFAULT_RENT_IMAGES = [
    'https://firebasestorage.googleapis.com/v0/b/studioskar.appspot.com/o/IMG_4373.JPG?alt=media&token=7aed5358-624b-4560-942d-86eb7def65ed',
    'https://firebasestorage.googleapis.com/v0/b/studioskar.appspot.com/o/IMG_4375.JPG?alt=media&token=5851d4b4-6174-41bf-8553-36bf03cd8e6e',
]

const DEFAULT_STUDIO_VIDEO = 'https://firebasestorage.googleapis.com/v0/b/studioskar.appspot.com/o/s115stronastudio%20(1).mp4?alt=media&token=e3446e9e-8ca9-4b15-a5c6-879a56545463'

const MainPage = () => {

    const [localData] = useContext<any>(Local_Data)

    const rentImages: string[] = localData?.mainPageMedia?.rentImages?.length
        ? localData.mainPageMedia.rentImages
        : DEFAULT_RENT_IMAGES

    const studioVideo: string = localData?.mainPageMedia?.studioVideo ?? DEFAULT_STUDIO_VIDEO

    const products = useMemo(() => toProductList(localData?.Products), [localData?.Products])

    return (
        <Styled.Page>
            <Hero
                videoSrc={studioVideo}
                imageSrc={rentImages[0]}
            />
            <GearRail products={products}/>
            <BrandMarquee products={products}/>
            <ContactBand/>
        </Styled.Page>
    )
}

export default MainPage
